////(function () {
//  // Function to get all the next siblings of an element
//  const nextSiblings = (currentElement) => {
//    let next_siblings = [];
//    let sibling = currentElement.nextElementSibling;

//    while (sibling) {
//      next_siblings.push(sibling);
//      sibling = sibling.nextElementSibling;
//    }

//    return next_siblings;
//  };

//  const footerDifferenceCalc = () => {
//    if (window.innerWidth > 989) {
//      let innerBlock = document.querySelector(
//        ".home_page_slider .footer--center_subscribe"
//      );
//      let sectionBlock = document.querySelector(
//        ".shopify-section-group-footer-group"
//      );
//      let innerHeight = innerBlock.offsetHeight;
//      let sectionHeight = sectionBlock.offsetHeight;

//      innerBlock.style.marginTop =
//        innerHeight > sectionHeight
//          ? 0 - parseInt(innerHeight - sectionHeight) + "px"
//          : 0;
//    }
//  };

//  const footer = () => {
//    const caculateNewsletterMargin = () => {
//      let timeout =
//        document?.querySelector(".home_page_slider") !== null ? 1500 : 0;

//      setTimeout(() => {
//        const footerNewsletter = document.querySelector(
//          ".footer--newsletter__form--center"
//        );

//        // Only proceed if the newsletter form exists
//        if (footerNewsletter) {
//          let footerParent = footerNewsletter.parentNode;
//          let footerStyles = window.getComputedStyle(footerParent);

//          // Calculate the total height of next siblings
//          let siblingsTotalHeight =
//            nextSiblings(footerNewsletter).reduce((totalHeight, sibling) => {
//              const siblingHeight = sibling.offsetHeight || 0; // Handle hidden elements
//              return totalHeight + siblingHeight;
//            }, 0) - parseInt(footerStyles.getPropertyValue("padding-top"), 10);

//          let windowHeight = window.outerHeight;
//          let newsletterHeight = footerNewsletter.offsetHeight;
//          let spaceLeft =
//            (windowHeight - siblingsTotalHeight - newsletterHeight) / 2;

//          paddingTop = spaceLeft > 0 ? spaceLeft : 0;

//          // Apply the calculated margin to the newsletter
//          footerNewsletter.style.paddingTop = `${paddingTop}px`;
//        }
//      }, timeout);
//    };

//    caculateNewsletterMargin();
//    setTimeout(() => footerDifferenceCalc(), 1500);

//    window.addEventListener("resize", () =>
//      setTimeout(() => caculateNewsletterMargin(), 1500)
//    );
//  };

//  // Reapply the footer logic when the section is reloaded
//  document.addEventListener("shopify:section:load", footer);
//  footer();
//})();

(function () {
	// Function to get all the next siblings of an element
	const nextSiblings = (currentElement) => {
		let next_siblings = [];
		let sibling = currentElement.nextElementSibling;

		while (sibling) {
			next_siblings.push(sibling);
			sibling = sibling.nextElementSibling;
		}

		return next_siblings;
	};

	const footerDifferenceCalc = () => {
		if (
			window.innerWidth > 989 &&
			document.querySelector(".home_page_slider .footer--center_subscribe") !==
				null
		) {
			//debugger;
			const innerBlock = document.querySelector(
				".home_page_slider .footer--center_subscribe"
			);
			const sectionBlock = document.querySelector(
				".shopify-section-group-footer-group"
			);

			if (!innerBlock || !sectionBlock) return;

			const innerHeight = innerBlock.offsetHeight;
			const sectionHeight = sectionBlock.offsetHeight;

			innerBlock.querySelector(
				".footer--newsletter__form--center"
			).style.marginTop = `${0 - (innerHeight - sectionHeight)}px`;
		}
	};

	const calculateNewsletterMargin = () => {
		return new Promise((resolve) => {
			const timeout =
				document.querySelector(".home_page_slider") !== null ? 700 : 0;

			setTimeout(() => {
				const footerNewsletter = document.querySelector(
					".footer--newsletter__form--center"
				);

				if (footerNewsletter) {
					// FIX: reset inline styles to prevent compounding from a prev calc-s
					footerNewsletter.style.paddingTop = "";
					footerNewsletter.style.marginTop = "";

					const footerParent = footerNewsletter.parentNode;
					const footerStyles = window.getComputedStyle(footerParent);

					const footerPaddingTop =
						parseInt(footerStyles.getPropertyValue("padding-top"), 10) || 0;
					const nextSiblingsTotalHeight = nextSiblings(footerNewsletter).reduce(
						(totalHeight, sibling) => {
							const siblingHeight = sibling.offsetHeight || 0;
							return totalHeight + siblingHeight;
						},
						0
					);
					const siblingsTotalHeight =
						nextSiblingsTotalHeight - footerPaddingTop;

					//const windowHeight = window.outerHeight
					// FIX: outerHeight also includes height of browser window (tabs, URL bar etc)
					const windowHeight = window.innerHeight;
					const newsletterHeight = footerNewsletter.offsetHeight;

					const spaceLeftTotal =
						windowHeight - siblingsTotalHeight - newsletterHeight;
					const spaceLeftAbove = spaceLeftTotal / 2;

					footerNewsletter.style.paddingTop = `${Math.max(
						spaceLeftAbove,
						0
					)}px`;

					// debug output
					//console.log(
					//	`calculateNewsletterMargin update padding`,
					//	JSON.stringify({
					//		windowHeight,
					//		windowWidth: window.innerWidth,
					//		footerPaddingTop,
					//		nextSiblingsTotalHeight,
					//		siblingsTotalHeight,
					//		newsletterHeight,
					//		spaceLeftTotal,
					//		spaceLeftAbove,
					//		paddingTop: footerNewsletter.style.paddingTop,
					//	})
					//);
				}

				resolve(); // Signal completion
			}, timeout);
		});
	};

	const displayPaddingAndMargin = () => {
		const footerNewsletter = document.querySelector(
			".footer--newsletter__form--center"
		);

		//console.log(
		//	`current padding and margin`,
		//	JSON.stringify({
		//		paddingTop: footerNewsletter.style.paddingTop,
		//		marginTop: footerNewsletter.style.marginTop,
		//	})
		//);
	};

	const footer = async () => {
		if (document.querySelector(".footer--newsletter__form--center") != null) {
			calculateNewsletterMargin()
				.then(footerDifferenceCalc)
				.then(displayPaddingAndMargin);
		}
	};

	// Reapply the footer logic when the section is reloaded
	document.addEventListener("shopify:section:load", footer);
	footer();

	// Productive #266 - a successful newsletter post reloads the page at
	// ?customer_posted=true#contact_form. The browser honours the anchor before
	// the lazy media above the footer has sized, so the block could land below
	// the fold and the shopper saw "the page simply reloads". Once the page has
	// finished loading, bring the confirmation into view (the Liquid renders it
	// in place of the field row, with the merchant's copy).
	const revealSubscribeConfirmation = () => {
		if (!/[?&]customer_posted=true/.test(window.location.search)) return;
		const message = document.querySelector(
			".footer-block--subscribe .newsletter-form__message--success"
		);
		if (!message) return;
		message.scrollIntoView({ block: "center" });
	};
	if (document.readyState === "complete") {
		revealSubscribeConfirmation();
	} else {
		window.addEventListener("load", () => setTimeout(revealSubscribeConfirmation, 250));
	}

	// Optimize resize event using debounce
	window.addEventListener("resize", () => {
		setTimeout(footer, 1000);
	});
})();

/* Productive #300 - footer subscribe without the page reload.
 * Shopify's customer form posts to /contact and answers with a redirect back to the
 * page (?customer_posted=true#contact_form), so the whole page re-rendered and the
 * browser jumped to the anchor before settling - the "glitch" the client reported.
 * The form is now posted in the background from here; on success the field row gives
 * way to the confirmation copy in place (the same swap the Liquid does after the
 * reload), on a validation error Shopify's message is shown under the field. Anything
 * unexpected (spam challenge page, network failure, no fetch) falls back to the
 * native submit, so the Liquid branches in footer.liquid still carry the outcome.
 * Copy comes from data-newsletter-success / data-newsletter-error on the block, set in
 * Liquid - no user-facing strings live here. */
(function () {
	"use strict";

	if (!window.fetch || !window.FormData || !window.DOMParser) return;

	function bind(block) {
		var form = block.querySelector("form.newsletter-form");
		if (!form || form.__billiniNewsletterBound) return;
		form.__billiniNewsletterBound = true;

		var successText = block.getAttribute("data-newsletter-success") || "";
		var errorText = block.getAttribute("data-newsletter-error") || "";

		function field() {
			return form.querySelector("input[type='email']");
		}

		function clearError() {
			var old = form.querySelector(".newsletter-form__message:not(.newsletter-form__message--success)");
			if (old) old.parentNode.removeChild(old);
			var input = field();
			if (input) {
				input.removeAttribute("aria-invalid");
				input.removeAttribute("aria-describedby");
			}
		}

		function showError(text) {
			clearError();
			var input = field();
			var wrapper = form.querySelector(".newsletter-form__field-wrapper") || form;
			var message = document.createElement("small");
			message.className = "newsletter-form__message form__message";
			message.id = (input && input.id ? input.id : "NewsletterForm") + "-error";
			message.setAttribute("role", "alert");
			message.textContent = text || errorText;
			wrapper.appendChild(message);
			if (input) {
				input.setAttribute("aria-invalid", "true");
				input.setAttribute("aria-describedby", message.id);
				input.focus({ preventScroll: true });
			}
		}

		function showSuccess() {
			clearError();
			var inner = form.querySelector(".newsletter-form__inner");
			if (inner) {
				/* The footer styles set display on the row, which beats [hidden]. */
				inner.hidden = true;
				inner.style.display = "none";
			}
			var message = document.createElement("p");
			message.className = "newsletter-form__message newsletter-form__message--success form__message";
			message.setAttribute("role", "status");
			message.setAttribute("tabindex", "-1");
			message.textContent = successText;
			form.appendChild(message);
			message.focus({ preventScroll: true });
		}

		function setBusy(busy) {
			var button = form.querySelector("button[type='submit']");
			if (busy) form.setAttribute("aria-busy", "true");
			else form.removeAttribute("aria-busy");
			if (button) button.disabled = !!busy;
		}

		function native() {
			setBusy(false);
			/* HTMLFormElement.submit() does not fire the submit event, so no loop. */
			form.submit();
		}

		form.addEventListener("submit", function (event) {
			if (form.getAttribute("aria-busy") === "true") {
				event.preventDefault();
				return;
			}
			event.preventDefault();
			setBusy(true);

			fetch(form.getAttribute("action") || "/contact", {
				method: "POST",
				body: new FormData(form),
				credentials: "same-origin",
				redirect: "follow",
				headers: { Accept: "text/html" }
			})
				.then(function (response) {
					var url = response.url || "";
					if (url.indexOf("/challenge") !== -1) return native();
					if (url.indexOf("customer_posted=true") !== -1) {
						setBusy(false);
						return showSuccess();
					}
					return response.text().then(function (html) {
						var doc = new DOMParser().parseFromString(html, "text/html");
						var error = doc.querySelector(".footer-block--subscribe .newsletter-form__message:not(.newsletter-form__message--success)");
						setBusy(false);
						if (error) return showError(error.textContent.replace(/\s+/g, " ").trim());
						if (response.ok) return showSuccess();
						showError(errorText);
					});
				})
				.catch(native);
		});
	}

	function init() {
		var blocks = document.querySelectorAll(".footer .footer-block--subscribe[data-newsletter-success]");
		for (var i = 0; i < blocks.length; i++) bind(blocks[i]);
	}

	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
	else init();
	document.addEventListener("shopify:section:load", init);
})();
